import axios from '@axios'
import store from '@/store'
import useAlert from '@/view-composables/common/useAlert'

export default function useAxios() {
  const logout = () => {
    setTimeout(() => {
      store.commit('logout')
      window.location.href = '/login'
    }, 1000)
  }

  const axiosGet = (urlData, page = null, params = undefined, setVersion = null) => {
    let url = urlData
    if (page) {
      url = url + '?page=' + page
    }

    if (localStorage.getItem('reload_data_v') && localStorage.getItem('reload_data_v') !== undefined && localStorage.getItem('reload_data_v') !== null && setVersion) {
      params.v = localStorage.getItem('reload_data_v')
    }
    return axios
      .get(url, {
        params: {
          ...params,
        },
      })
      .then(response => response.data)
      .catch(error => {
        if (error.response.status === 401) {
          useAlert().errorUnauthorizedAlert()

          logout()
        } else if (error.response.status === 422) {
          useAlert().errorAlert(error.response.data.message)
        } else {
          useAlert().errorAlert('خطایی رخ داده است.')
        }
      })
  }

  const axiosPost = (urlData, data, page = null, setVersion = null) => {
    let url = urlData
    if (page) {
      url = url + '?page=' + page
    }

    if (localStorage.getItem('reload_data_v') && localStorage.getItem('reload_data_v') !== undefined && localStorage.getItem('reload_data_v') !== null && setVersion) {
      data.v = localStorage.getItem('reload_data_v')
    }
    return axios.post(url, data)
      .then(response => response.data)
      .catch(error => {
        if (error.response.status === 401) {
          useAlert()
            .errorUnauthorizedAlert()

          logout()
        } else {
          useAlert()
            .errorAlert('خطایی رخ داده است.')
        }
      })
  }

  const axiosUploadFile = (url, data) => axios.post(url, data, {
    'Content-Type': 'multipart/form-data',
  })
    .then(response => response.data)
    .catch(error => {
      if (error.response.status === 401) {
        useAlert()
          .errorUnauthorizedAlert()

        logout()
      } else {
        useAlert()
          .errorAlert('خطایی رخ داده است.')
      }
    })

  const axiosPut = (urlData, data, page = null) => {
    let url = urlData
    if (page) {
      url = url + '?page=' + page
    }

    return axios.put(url, data)
      .then(response => response.data)
      .catch(error => {
        if (error.response.status === 401) {
          useAlert()
            .errorUnauthorizedAlert()

          logout()
        } else {
          useAlert()
            .errorAlert('خطایی رخ داده است.')
        }
      })
  }

  const axiosPatch = (urlData, data, page = null) => {
    let url = urlData
    if (page) {
      url = url + '?page=' + page
    }

    return axios
      .patch(url, data)
      .then(response => response.data)
      .catch(error => {
        if (error.response.status === 401) {
          useAlert().errorUnauthorizedAlert()
          logout()
        } else {
          useAlert().errorAlert('خطایی رخ داده است.')
        }
      })
  }

  const axiosDelete = (url, data) => axios.delete(url, data)
    .then(response => response.data)
    .catch(error => {
      if (error.response.status === 401) {
        useAlert()
          .errorUnauthorizedAlert()

        logout()
      } else {
        useAlert()
          .errorAlert('خطایی رخ داده است.')
      }
    })

  return {
    axiosUploadFile,
    axiosDelete,
    axiosPost,
    axiosPut,
    axiosPatch,
    axiosGet,
  }
}
